export const Admin = 'Admin';
export const User = 'User';
export const Operator = 'Operator';
export const Transporter = 'Transporter';